export default __webpack_public_path__ + "static/media/NestLogo.f0004e9b.png";